import React, { useEffect, useState } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import axios from "axios";

const CreditCardInfoModal = ({ show, handleClose }) => {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch existing card details when modal opens
  useEffect(() => {
    if (show) {
      fetchCardInfo();
    }
  }, [show]);

  const fetchCardInfo = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.get("/api/billing/card-info"); // Backend route for Tap Gateway
      reset({
        cardholder_name: data.cardholder_name || "",
        masked_pan: data.masked_pan || "",
        expiry_month: data.expiry_month || "",
        expiry_year: data.expiry_year || "",
      });
    } catch (err) {
      setError("Failed to fetch card details.");
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (formData) => {
    try {
      await axios.post("/api/billing/update-card", formData);
      handleClose();
    } catch (err) {
      setError("Failed to update card info.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Card Info</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" size="sm" /> Loading...
          </div>
        ) : (
          <Form onSubmit={handleSubmit(onSubmit)}>
            {error && <p className="text-danger">{error}</p>}

            <Form.Group className="mb-3">
              <Form.Label>Card Holder Name</Form.Label>
              <Form.Control
                type="text"
                {...register("cardholder_name", { required: "Card holder name is required" })}
                isInvalid={!!errors.cardholder_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.cardholder_name?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Card Number</Form.Label>
              <Form.Control
                type="text"
                {...register("masked_pan", { required: "Card number is required" })}
                isInvalid={!!errors.masked_pan}
              />
              <Form.Control.Feedback type="invalid">
                {errors.masked_pan?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Expiry Month</Form.Label>
              <Form.Control
                type="number"
                {...register("expiry_month", { required: "Expiry month is required" })}
                isInvalid={!!errors.expiry_month}
              />
              <Form.Control.Feedback type="invalid">
                {errors.expiry_month?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Expiry Year</Form.Label>
              <Form.Control
                type="number"
                {...register("expiry_year", { required: "Expiry year is required" })}
                isInvalid={!!errors.expiry_year}
              />
              <Form.Control.Feedback type="invalid">
                {errors.expiry_year?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-flex justify-content-end">
              <Button variant="secondary" onClick={handleClose} className="me-2">
                Cancel
              </Button>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Updating..." : "Update"}
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CreditCardInfoModal;
